import { LocalStorage } from 'helpers/localStorage';

export const ABTestingStore = (experiment: string) =>
  new LocalStorage<{ name: string }, null>(experiment, null);
